// src/components/foam/FoamSerialHelp.js
//
// "Where do I find my serial?" drawer — shown on the root SKU input screen.
// Closes critique #6 from the Claude Design handoff.
//
// Phase 1: a labelled photo + caption. Photo URL can be replaced with the
// actual product-photography asset when available.

import React, { useState } from 'react';
import { FLabel } from './FoamPrimitives';

// Real photo (Nigel, 2026-06-04): the MY WAKA QR/serial sticker sits on the
// BOTTOM of the board, below the foil tracks. Served from public/images/ so a
// missing file degrades gracefully (onError hides the img, caption remains).
const SERIAL_PHOTO_URL = `${process.env.PUBLIC_URL}/images/serial-location.jpg`;

const FoamSerialHelp = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-t border-foam-hair pt-[14px]">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between w-full text-left"
      >
        <FLabel>Where do I find my serial?</FLabel>
        <span className="font-mono text-[12px] text-foam-ink-2">
          {open ? '−' : '+'}
        </span>
      </button>
      {open && (
        // min-w-0 + overflow-hidden: without these, the image's intrinsic
        // width makes this flex child wider than the viewport and the whole
        // screen pans horizontally (Nigel, 2026-06-05 iPhone re-test).
        <div className="mt-[14px] flex flex-col gap-[10px] min-w-0 overflow-hidden">
          <div className="bg-foam-paper-2 p-[18px] min-w-0">
            <img
              src={SERIAL_PHOTO_URL}
              alt="Photo showing where the serial sticker is located on a WAKA board"
              className="block w-full h-auto"
              style={{ maxWidth: '100%', maxHeight: 300, objectFit: 'cover', objectPosition: 'center 65%' }}
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
            <div className="font-mono text-[12px] tracking-[0.1em] uppercase text-foam-ink-2 mt-[10px]">
              Bottom of the board · below the foil tracks
            </div>
          </div>
          <div className="text-[14px] leading-[1.5] text-foam-ink-2">
            Your serial looks like <span className="font-mono">GLIDE-88-V2-A0427</span>.
            It's on the white MY WAKA sticker on the bottom of the board,
            just below the foil tracks — scan the QR code or type the serial.
            If you can't find it, contact{' '}
            <a
              href="mailto:hello@waka.surf?subject=Help%20finding%20my%20serial"
              className="underline"
            >
              hello@waka.surf
            </a>{' '}
            with a photo and we'll help.
          </div>
        </div>
      )}
    </div>
  );
};

export default FoamSerialHelp;
